var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningToDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.138 1.0516C11.5247 0.394192 12.4753 0.394194 12.862 1.0516L23.2381 18.6946C23.6302 19.3613 23.1495 20.2016 22.3761 20.2016H1.62388C0.850504 20.2016 0.369843 19.3613 0.7619 18.6946L11.138 1.0516Z",
    fill: "#AC3A06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.44 16.4941V15.5041H12.322V16.4941H11.44ZM11.44 14.3341V7.85414H12.322V14.3341H11.44Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningToDelete);
export default __webpack_public_path__ + "static/media/WarningToDelete.82c5fbb2bcd12366ae6cad9312fe190d.svg";
export { ForwardRef as ReactComponent };